var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.493 4.006l5.5 5.5L6.049 21.452l-4.9.541a1.031 1.031 0 01-1.142-1.139l.546-4.908 11.94-11.94zm8.9-.819L18.813.599a2.063 2.063 0 00-2.918 0l-2.43 2.43 5.5 5.5 2.43-2.43a2.064 2.064 0 000-2.918z"
  })));
}

export default SvgIconPen;